import React from 'react';

import {
  IconCalendarClock,
  IconHelp,
  IconMessageUser,
  IconMoodConfuzed,
  IconMoodCry,
  IconMoodHappy,
  IconMoodHeart,
  IconMoodLookUp,
  IconMoodSad,
  IconMoodSmile,
  IconQuestionMark,
  IconUserExclamation,
  IconZoomQuestion
} from '@tabler/icons-react';
import i18n from 'i18n';
import { IntentClassification, SentimentAnalysis } from 'shared/interfaces/ConversationAnalysis';

export type AnalysisInfo = {
  color: string;
  icon: React.ReactNode;
  label: string;
};

export const defaultAnalysisInfo: AnalysisInfo = {
  color: 'gray',
  icon: <IconQuestionMark />,
  label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.DEFAULT_ANALYSIS_INFO')
};

export const sentimentInfo: Record<SentimentAnalysis, AnalysisInfo> = {
  [SentimentAnalysis.VERY_POSITIVE]: {
    color: 'green',
    icon: <IconMoodHappy />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.SENTIMENT.VERY_POSITIVE')
  },
  [SentimentAnalysis.POSITIVE]: {
    color: 'lime',
    icon: <IconMoodSmile />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.SENTIMENT.POSITIVE')
  },
  [SentimentAnalysis.SLIGHTLY_POSITIVE]: {
    color: 'teal',
    icon: <IconMoodHeart />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.SENTIMENT.SLIGHTLY_POSITIVE')
  },
  [SentimentAnalysis.NEUTRAL]: {
    color: 'gray',
    icon: <IconMoodLookUp />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.SENTIMENT.NEUTRAL')
  },
  [SentimentAnalysis.SLIGHTLY_NEGATIVE]: {
    color: 'orange',
    icon: <IconMoodConfuzed />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.SENTIMENT.SLIGHTLY_NEGATIVE')
  },
  [SentimentAnalysis.NEGATIVE]: {
    color: 'red',
    icon: <IconMoodSad />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.SENTIMENT.NEGATIVE')
  },
  [SentimentAnalysis.VERY_NEGATIVE]: {
    color: 'pink',
    icon: <IconMoodCry />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.SENTIMENT.VERY_NEGATIVE')
  }
};

export const intentInfo: Record<IntentClassification, AnalysisInfo> = {
  [IntentClassification.APPOINTMENT]: {
    color: 'blue',
    icon: <IconCalendarClock />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.INTENT.APPOINTMENT')
  },
  [IntentClassification.INQUIRY]: {
    color: 'cyan',
    icon: <IconZoomQuestion />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.INTENT.INQUIRY')
  },
  [IntentClassification.COMPLAINT]: {
    color: 'red',
    icon: <IconUserExclamation />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.INTENT.COMPLAINT')
  },
  [IntentClassification.FEEDBACK]: {
    color: 'grape',
    icon: <IconMessageUser />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.INTENT.FEEDBACK')
  },
  [IntentClassification.SUPPORT]: {
    color: 'teal',
    icon: <IconHelp />,
    label: i18n.t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALL_ANALYSIS.INTENT.SUPPORT')
  }
};
